'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaSteam = function FaSteam(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35.3 13q0 2.2-1.6 3.8t-3.8 1.6-3.9-1.6-1.6-3.8 1.6-3.9 3.9-1.6 3.8 1.6 1.6 3.9z m-17.2 16.6q0-2.4-1.6-4t-4-1.6q-0.6 0-1.2 0.1l2.4 0.9q1.7 0.7 2.4 2.4t0 3.4q-0.7 1.7-2.3 2.4t-3.4 0.1q-0.5-0.2-1.4-0.6t-1.4-0.5q0.7 1.3 2 2.1t2.9 0.8q2.4 0 4-1.6t1.6-3.9z m18.6-16.6q0-2.8-2-4.8t-4.9-2q-2.8 0-4.8 2t-2 4.8q0 2.8 2 4.8t4.8 2q2.9 0 4.9-2t2-4.8z m3.3 0q0 4.2-3 7.2t-7.2 3l-9.7 7.1q-0.3 2.9-2.4 4.9t-5.2 1.9q-2.7 0-4.7-1.6t-2.7-4.3l-5.1-2.1v-9.6l8.7 3.5q1.7-1 3.8-1 0.3 0 0.8 0l6.4-9.1q0-4.1 3-7.1t7.1-2.9q4.2 0 7.2 2.9t3 7.2z' })
        )
    );
};

exports.default = FaSteam;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/steam.js
// module id = 1096
// module chunks = 168707334958949